import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService, UIService } from 'src/app/_services';
import { ConfirmationDialogService } from 'src/app/_services/cdialog.service';
import { PartnersService } from 'src/app/_services/partners.service';
import { Partner } from 'src/types/Partner';

@Component({
  selector: 'app-partner-view',
  templateUrl: './partner-view.component.html',
  styleUrls: ['./partner-view.component.scss']
})
export class PartnerViewComponent implements OnInit {
  partner: Partner;
  loading: boolean = false;
  deleted: boolean = false;

  constructor(
    private partnerService: PartnersService,
    private confirmationService: ConfirmationDialogService,
    private alertService: AlertService,
    private location: Location,
    private UIService: UIService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.UIService.setTitle('View Partner');
    
    // Try to get partner from navigation state first (for better UX)
    if (history.state.data && history.state.data.partner) {
      this.partner = history.state.data.partner;
    } else {
      // If not available in state, fetch from API using route parameter
      const partnerId = this.route.snapshot.paramMap.get('id');
      if (partnerId) {
        this.loading = true;
        this.partnerService.getPartnerById(partnerId).subscribe(
          ({ partner }) => {
            this.partner = partner;
            this.loading = false;
          },
          ({ error }) => {
            this.loading = false;
            error.statusCode && error.statusCode === 400 ?
              this.alertService.error(error.message) :
              this.alertService.error("Failed to load partner details!");
          }
        );
      }
    }

    

    console.log({ partner: this.partner})
  }

  navigateBack() {
    this.location.back();
  }

  deletePartner() {
    this.confirmationService.confirm('Confirmation', `Do you really want to delete partner "${this.partner.name}"? This action is permanent.`)
    .then(confirmed => {
      if(confirmed) {
        // delete partner
        this.loading = true;
        this.partnerService.deletePartner(this.partner.id).subscribe(
          () => {
            this.alertService.success('Partner deletion queued successfully');
            this.loading = false;
            this.deleted = true;
          },
          ({ error }) => {
            this.loading = false;
            error.statusCode && error.statusCode === 400 ?
              this.alertService.error(error.message) :
              this.alertService.error("Something went wrong!");
          }
        )
      }
    }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

}
